import { render, staticRenderFns } from "./Form.vue?vue&type=template&id=a984eb9a&"
import script from "./Form.vue?vue&type=script&lang=js&"
export * from "./Form.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('a984eb9a')) {
      api.createRecord('a984eb9a', component.options)
    } else {
      api.reload('a984eb9a', component.options)
    }
    module.hot.accept("./Form.vue?vue&type=template&id=a984eb9a&", function () {
      api.rerender('a984eb9a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/Device/Form.vue"
export default component.exports